import { Typography } from "antd";


/** get items column */
export const unitColumn = ({handleChoose})=>{
    const Link = Typography.Link;
    return [
      // {
      //   title: "รหัสลูกค้า",
      //   key: "cuscode",
      //   dataIndex: "cuscode", 
      //   render: (v, record) => <Link className="text-select" onClick={()=>handleChoose(record)}>{v}</Link>
      // },
      {
        title: "ชื่อยี่ห้อ",
        dataIndex: "value",
        key: "value",
        render: (v, record) => <Link className="text-select" onClick={()=>handleChoose(record)}> {v}</Link>
      } 
    ]
  };